var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompare({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9808 7.935C16.9136 7.81727 16.8308 7.73511 16.7034 7.68988L13.0109 6.34585C13.0249 5.94473 12.8795 5.5393 12.5739 5.23397C11.9452 4.60469 10.8946 4.65525 10.3338 5.37133L6.64695 4.02963C6.38885 3.9375 6.12776 4.07387 6.03064 4.27376L3.69413 8.91351H4.81133L6.47865 5.60216L8.16626 8.91351H9.28612L7.49574 5.40027L10.0168 6.31791C10.0271 6.95883 10.4366 7.5013 11.0156 7.70618V17.3961C11.0156 17.6715 11.2391 17.895 11.5145 17.895C11.7899 17.895 12.0134 17.6715 12.0134 17.3961V7.70618C12.2566 7.6207 12.4751 7.47303 12.646 7.2748L15.837 8.43623L13.7366 12.6087H14.8538L16.5351 9.26873L18.2177 12.6087H19.3349L16.9808 7.935ZM11.8684 6.64718C11.6732 6.84242 11.3559 6.84242 11.1606 6.64718C10.9654 6.45195 10.9654 6.13465 11.1606 5.93941C11.3559 5.74418 11.6732 5.74418 11.8684 5.93941C12.064 6.13498 12.0643 6.45128 11.8684 6.64718Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1019 16.9305H10.9272C9.50962 16.9305 8.3565 18.0836 8.3565 19.5011C8.3565 19.7765 8.58001 20 8.8554 20H14.1737C14.449 20 14.6726 19.7765 14.6726 19.5011C14.6726 18.0836 13.5194 16.9305 12.1019 16.9305Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5302 13.6065H13.5417C13.2663 13.6065 13.0428 13.83 13.0428 14.1054C13.0428 16.0315 14.6097 17.5983 16.5358 17.5983C18.4619 17.5983 20.0287 16.0315 20.0287 14.1054C20.0287 13.83 19.8056 13.6065 19.5302 13.6065Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.489 9.91164H3.4989C3.22351 9.91164 3 10.1351 3 10.4105C3 12.3373 4.56721 13.9045 6.49395 13.9045C8.4207 13.9045 9.9879 12.3373 9.9879 10.4105C9.9879 10.1351 9.7644 9.91164 9.489 9.91164Z",
    fill: "inherit"
  })));
}

export default SvgCompare;